import React, { useCallback, useLayoutEffect, useRef } from 'react'
import { Animated } from 'react-native'
import Color from 'color'
import { isWeb } from 'APP/Helpers/checkPlatform'
import { useTheme } from 'styled-components/native'

// Components
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Icon from 'APP/Converse/Icon'
import { StyledContainer, StyledInputContainer, StyledInput, StyledSearchIcon } from './style'

const ClearInput = ({ show, onPress }) => {
  const animatedState = useRef(new Animated.Value(0)).current

  useLayoutEffect(() => {
    Animated.spring(animatedState, {
      toValue: show ? 1 : 0,
      speed: 12,
      useNativeDriver: true,
    }).start()
  }, [show])

  const AnimatedStyles = {
    transform: [{ scale: animatedState }],
    opacity: animatedState.interpolate({ inputRange: [0, 0.5, 1], outputRange: [0, 0, 1] }),
  }

  return (
    <Animated.View style={AnimatedStyles} testID="clear-input">
      <DialogueTouchableOpacity
        activeOpacity={0.5}
        onPress={onPress}
        analyticsName="SearchField.clear"
        tabIndex={show ? 0 : -1}
        accessibilityRole="button"
        testID="CLEAR_SEARCH_BUTTON"
      >
        <Icon src="close-circle" variant="material" color="disabled" size={25} />
      </DialogueTouchableOpacity>
    </Animated.View>
  )
}

const SearchField = ({
  value,
  onChange,
  placeholder,
  showClearButton,
  onClearButtonPress,
  disabled,
  style = {},
}) => {
  const theme = useTheme()

  const FocusBorderColor = Color(theme.colors.accent).rgb().string()
  const BlurBorderColor = Color(theme.colors.accent).alpha(0).rgb().string()

  const animatedState = useRef(new Animated.Value(0)).current
  const onFocus = useCallback(() => {
    Animated.timing(animatedState, {
      toValue: 1,
      duration: 250,
      useNativeDriver: false,
    }).start()
  }, [])
  const onBlur = useCallback(() => {
    Animated.timing(animatedState, {
      toValue: 0,
      duration: 250,
      useNativeDriver: false,
    }).start()
  }, [])

  const animatedStyle = {
    borderWidth: 1,
    borderColor: animatedState.interpolate({
      inputRange: [0, 1],
      outputRange: [BlurBorderColor, FocusBorderColor],
    }),
  }

  return (
    <StyledContainer style={style}>
      {isWeb() && <StyledSearchIcon src="magnify" variant="material" color="accent" size={24} />}
      <StyledInputContainer style={animatedStyle}>
        {!isWeb() && <StyledSearchIcon src="magnify" variant="material" color="accent" size={24} />}
        <StyledInput
          testID="SEARCH_FIELD"
          returnKeyType="search"
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          placeholderTextColor={theme.colors.buttonPrimarySelected}
          selectionColor={theme.colors.accent}
          onChangeText={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          renderErrorMessage={false}
        />
        <ClearInput show={showClearButton} onPress={onClearButtonPress} />
      </StyledInputContainer>
    </StyledContainer>
  )
}

export default SearchField
